export const getWarehouseOrderDownloadUrl = (rootUrl: string) => (fileId: number) => {
	const url = new URL(`${rootUrl}/warehouse-order/file?fileId=${fileId}`);
	return `${url}`;
};
